import React, {useEffect, useState} from "react";
import {cloneDeep} from "lodash";
import {arrayIncludeItem} from "@app/utils/CommonUtils";
import Select from "react-select";
import {SavedListTabOptions} from "@pages/savedlist/common/Constant";
import {requestGetJobList} from "@app/services/JobService";
import {requestGetUserEmailList} from "@app/services/UserService";
import Button from "react-bootstrap/Button";
import RunJobParentTabContent, {
    RunJobParentTabIds,
    RunJobParentTabs
} from "@pages/job/runjob/RunJobParentTabContent";
import {pipelineOptionsToString} from "@pages/jobpipeline/common/PipelineUtil";
import {requestSaveJobPipeline} from "@app/services/JobPipelineService";
import {ResponseCode} from "@app/constants/Common";
import {alertMessage} from "@app/constants/Messages";

const RunJobDetailInfo = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [currentParentTab, setCurrentParentTab] = useState(RunJobParentTabs[1]);
    const [runJobInfo, setRunJobInfo] = useState({
        'email_tab': {
            'not_permission_email_candidate_ids': [],
            'need_checking_candidate_ids': [],
            'need_input_info_candidate_ids': [],
            'approve_draft_candidate_ids': [],
            'send_by_week_candidate_ids': [],
            'sent_email_in_week_candidate_ids': [],
            'send_when_unlimited_candidate_ids': [],
        }
    });

    const {runJob} = props

    useEffect(() => {
        if (runJob) {
            setRunJobInfo({...runJob})
        }
    }, [runJob]);

    // const onUpdateRunJobInfo = () => {
    //     const body = pipelineOptionsToString(runJobInfo)
    //     requestSaveJobPipeline(body).then((res) => {
    //         // if (res.sts_code === ResponseCode.SUCCESS) {
    //         //     onClose(res.sts_code === ResponseCode.SUCCESS)
    //         // } else {
    //         //     alertMessage(res.sts_code)
    //         // }
    //     }).catch((error) => {
    //         console.log(`Error:${JSON.stringify(error)}`);
    //     }).finally(() => {
    //         setIsLoading(false);
    //     });
    // }


    const activeTab = (tab) => {
        if (currentParentTab.id === tab.id) {
            return 'active'
        }
        return ''
    }

    return (
        <div className="card card-default">
            <div className="card-header">
                <h3 className="card-title text-bold">Run job detail info</h3>
                <button type="button" className="btn btn-tool" data-card-widget="collapse">
                    <i className="fas fa-minus"/>
                </button>
                <div className="card-tools pr-2">
                    <Button type='button'
                            className='btn btn-primary'
                            isLoading={isLoading}
                            disabled={isLoading}
                            onClick={() => {

                            }}
                    >
                        {/*<i className='fas fa-save mr-2'/>*/}
                        Save
                    </Button>
                </div>
            </div>
            <div className="card-body">
                <ul className='nav nav-tabs' role='tablist'>
                    {RunJobParentTabs.map(tab => (
                        <li className='nav-item' key={tab.id}>
                            <a className={`nav-link ${activeTab(tab)}`} data-toggle='tab' href={`#${tab.id}`}
                               onClick={() => {setCurrentParentTab(tab)}}>{tab.title}</a>
                        </li>
                    ))}
                </ul>
                <div className='tab-content'>
                    {RunJobParentTabs.map((tab, index) => {
                        if (currentParentTab.id === tab.id) {
                            return <div id={tab.id} className={`tab-pane active`}>
                                <RunJobParentTabContent runJob={runJobInfo} parentTab={tab}/>
                            </div>
                        }
                        return ""
                    })}
                    {/*<div id={"pre-email-tab"} className={`tab-pane`}>*/}
                    {/*    <SendMailInviteJobContent runJob={runJobInfo} parentTab={RunJobParentTabIds.PRE_EMAIL}/>*/}
                    {/*</div>*/}
                    {/*<div id={"pre-email-tab"} className={`tab-pane`}>*/}
                    {/*    <SendMailInviteJobContent runJob={runJobInfo} parentTab={RunJobParentTabIds.PRE_EMAIL}/>*/}
                    {/*</div>*/}
                    {/*<div id={"email-tab"} className={`tab-pane  ${activeTab(tab)}`}>*/}
                    {/*    <SendMailInviteJobContent runJob={runJobInfo} parentTab={RunJobParentTabIds.EMAIL_TAB}/>*/}
                    {/*</div>*/}
                    {/*<div id={"feedback-email-tab"} className={`tab-pane`}>*/}
                    {/*</div>*/}
                    {/*<div id={"contact-each-tab"} className={`tab-pane`}>*/}
                    {/*</div>*/}
                    {/*<div id={"process-to-client-tab"} className={`tab-pane`}>*/}
                    {/*</div>*/}
                    {/*<div id={"payment-guarantee-tab"} className={`tab-pane`}>*/}
                    {/*</div>*/}
                </div>
            </div>
        </div>
    )
}

export default RunJobDetailInfo;
